import { render, staticRenderFns } from "./leftthree.vue?vue&type=template&id=12dd75d3&scoped=true&"
import script from "./leftthree.vue?vue&type=script&lang=js&"
export * from "./leftthree.vue?vue&type=script&lang=js&"
import style0 from "./leftthree.vue?vue&type=style&index=0&id=12dd75d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd75d3",
  null
  
)

export default component.exports